import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  DataGridCustom,
  Grid,
  Input,
  Table,
  Button,
} from '../../../components/index';
import RequerimentosConflitosPeriodos from './RequerimentosConflitosPeriodos';
import * as listUtils from '../../../utils/listsSelect';
import VisualizacaoPeriodos from './VisualizacaoPeriodos';

const VAZIO = '';
class DadosConflitosPeriodos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exibirGrafico: false,
      idLinhaExpandida: null,
      parametrosGrafico: {
        periodoReqCorrente: null,
        periodoReqConflito: null,
        periodoConflito: null,
        protocoloCorrente: null,
        protocoloConflito: null,
        solicitanteCorrente: null,
        destinatarioCorrente: null,
        solicitanteConflito: null,
        destinatarioConflito: null,
      },
    };
  }

  getTagStatus() {
    const listaEstados = listUtils.estadoConflitoSimplificado;
    if (this.props.conflitoPeriodos.idConflito) {
      let estadoCss = '';
      switch (this.props.conflitoPeriodos.estadoConflito) {
        case 0:
          estadoCss = 'estadoNaoResolvido';
          break;
        case 1: case 2: case 3: case 4: case 5: case 6:
          estadoCss = 'estadoResolvido';
          break;
        default:
          estadoCss = '';
      }

      return (
        <div
          className={estadoCss}
          style={{
            textAlign: 'center',
            fontSize: '12px',
            maxWidth: 'inherit',
            padding: '5px 7px 5px 7px',
            minHeight: 'inherit',
          }}
        >
          {listUtils.getObject(listaEstados, this.props.conflitoPeriodos.estadoConflito).label}
        </div>
      );
    }
    return (<div>.</div>);
  }

  addTipoEstadoLabel = (tipo) => {
    if (tipo === undefined || tipo === null) {
      return '';
    }
    return listUtils.getObject(listUtils.estadoConflito, tipo).label;
  };

  createColunaConflitoPeriodos = (cell, row) => {
    const temPeriodoConflito =
      row.periodoConflito !== null &&
      row.periodoConflito !== VAZIO;

    return (
      <React.Fragment>
        {temPeriodoConflito && (
          <Grid cols="12 12 12 12" style={{ textAlign: 'center' }}>
            <span style={{ color: 'red' }}>
              {row.periodoConflito}
            </span>
          </Grid>
        )}
      </React.Fragment>
    );
  };

  showGrafico = (row) => {
    const grafico = {
      periodoReqCorrente: row.periodoReqCorrente,
      periodoReqConflito: row.periodoReqConflito,
      periodoConflito: row.periodoConflito,
      protocoloCorrente: this.props.conflitoPeriodos.requerimentoCorrente.protocolo,
      protocoloConflito: this.props.conflitoPeriodos.requerimentoConflitante.protocolo,
      solicitanteCorrente: `${this.props.conflitoPeriodos.requerimentoCorrente.nomeSolicitante} - ${this.props.conflitoPeriodos.requerimentoCorrente.codigoSolicitante}`,
      destinatarioCorrente: `${this.props.conflitoPeriodos.requerimentoCorrente.nomeDestinatario} - ${this.props.conflitoPeriodos.requerimentoCorrente.codigoDestinatario}`,
      solicitanteConflito: `${this.props.conflitoPeriodos.requerimentoConflitante.nomeSolicitante} - ${this.props.conflitoPeriodos.requerimentoConflitante.codigoSolicitante}`,
      destinatarioConflito: `${this.props.conflitoPeriodos.requerimentoConflitante.nomeDestinatario} - ${this.props.conflitoPeriodos.requerimentoConflitante.codigoDestinatario}`,
    };
    this.setState({
      exibirGrafico: true,
      parametrosGrafico: grafico,
      idLinhaExpandida: row.idPeriodoCorrente,
    });
  }

  fecharGrafico = () => {
    this.setState({
      exibirGrafico: false,
      idLinhaExpandida: null,
    });
  }

  montaAcaoGrafico = (row) => {
    const aberta = this.state.idLinhaExpandida === row.idPeriodoCorrente;
    return (
      <React.Fragment>
        <Button
          hint={aberta
            ? 'Fechar gráfico do conflito de períodos'
            : 'Exibir gráfico do conflito de períodos'}
          icon={aberta ? 'ico-cancel' : 'ico-magnifier'}
          mini
          onClick={aberta
            ? () => this.fecharGrafico()
            : () => this.showGrafico(row)}
          className={aberta ? 'dtp-inverse' : VAZIO}
        />
      </React.Fragment>
    );
  };

  createColunaGrafico = (cell, row) => (
    this.montaAcaoGrafico(row)
  )

  tableHeader = [{
    id: 'idPeriodoCorrente',
    label: 'Sequencial do Período',
  }, {
    id: 'periodoReqCorrente',
    label: 'Período Original Requerimento Corrente',
  }, {
    id: 'periodoReqConflito',
    label: 'Período Original Requerimento Conflitante',
  }, {
    id: 'periodoConflito',
    label: 'Período Conflitante',
    dataFormat: this.createColunaConflitoPeriodos,
  }, {
    id: 'grafico',
    label: 'Painel de Períodos',
    dataFormat: this.createColunaGrafico,
  }];

  verificarTamanhoInput = (value) => {
    if (value === undefined || value === null) {
      return '';
    }
    const qtdMaxCharacterInput = 42;
    return value.length > qtdMaxCharacterInput ? value : '';
  }

  render() {
    const { acao } = this.props;
    const exibirCheckbox = (acao === 'realizar-analise');
    const listaIndexada = this.props.conflitoPeriodos.conflitosPeriodos ?
      this.props.conflitoPeriodos.conflitosPeriodos.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.acoes = i;
        return itemIndexado;
      }) : null;

    const options = {
      hideSizePerPage: true,
      noDataText: 'Nenhum período adicionado à lista',
      sizePerPage: 10,
    };
    return (
      <React.Fragment>
        <div style={{ float: 'right' }}>{this.getTagStatus()}</div>
        <DataGridCustom title="Dados do Conflito">
          <div className="row">
            <Grid cols="12 12 12 12">
              <Input
                disabled
                label="Estado do conflito"
                value={this.addTipoEstadoLabel(this.props.conflitoPeriodos.estadoConflito)}
                title={this.verificarTamanhoInput(this.addTipoEstadoLabel(this.props.conflitoPeriodos.estadoConflito))}
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Sequencial do conflito"
                value={this.props.conflitoPeriodos.idConflito}
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Data de criação"
                value={this.props.conflitoPeriodos.dataCriacaoConflito}
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Data de resolução"
                value={this.props.conflitoPeriodos.dataResolucao}
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Resolvido por"
                value={this.props.conflitoPeriodos.nomeResolvedor !== '' ?
                  `${this.props.conflitoPeriodos.nomeResolvedor}` : ''}
              />
            </Grid>
          </div>
        </DataGridCustom>
        <RequerimentosConflitosPeriodos
          requerimentoConflito={this.props.conflitoPeriodos.requerimentoCorrente}
          titulo="Dados do Requerimento Corrente"
          handleChange={this.props.handleChange}
          exibirCheckbox={exibirCheckbox}
          idConflito={this.props.conflitoPeriodos.idConflito}
          status={this.props.conflitoPeriodos.estadoConflito}
          onUpdateConflito={this.props.atualizarConflitosPeriodos}
        />
        <RequerimentosConflitosPeriodos
          requerimentoConflito={this.props.conflitoPeriodos.requerimentoConflitante}
          titulo="Dados do Requerimento Conflitante"
          handleChange={this.props.handleChange}
          exibirCheckbox={false}
          status={this.props.conflitoPeriodos.estadoConflito}
          onUpdateConflito={this.props.atualizarConflitosPeriodos}
        />
        <div className="row">
          <Table
            bordered
            insertRow={false}
            data={listaIndexada}
            options={options}
            listaTableHeader={this.tableHeader}
            pagination
            fetchInfo={this.fetchInfo}
          />
        </div>
        {this.state.exibirGrafico &&
          <div className="row">
            <VisualizacaoPeriodos parametros={this.state.parametrosGrafico} />
          </div>
        }
      </React.Fragment>
    );
  }
}

DadosConflitosPeriodos.propTypes = {
  conflitoPeriodos: PropTypes.objectOf(PropTypes.object).isRequired,
  atualizarConflitosPeriodos: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  acao: PropTypes.string.isRequired,
};

export default DadosConflitosPeriodos;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Aposentadoria/DadosConflitosPeriodos.jsx